import { render, staticRenderFns } from "./BookCreate.vue?vue&type=template&id=dc94f3bc&"
import script from "./BookCreate.vue?vue&type=script&lang=js&"
export * from "./BookCreate.vue?vue&type=script&lang=js&"
import style0 from "./BookCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports